import { buildRoute } from '@direct-frontend/modules-router';

export const emailConstructorRoute = buildRoute('/email-constructor');
